<template>
    <div  class="echarts" ref="myEchart">
    </div>
</template>

<script>
    import * as echarts from "echarts"
    export default {
        name: "echarts",
        data(){
            return {
                chart:''
            }
        },
        props: {
            chartsOption: {
                type: Object,
                default() {
                    return {};
                }
            }
        },
        watch:{
            chartsOption:{
                handler(newValue,oldValue){
                    this.chart.setOption(newValue)
                    this.chartresize()
                },
                deep:true,
            }
        },
        mounted(){
            this.initChart()
        },
        methods:{
            initChart(){

                this.chart = echarts.init(this.$refs.myEchart);
                this.chart.setOption(this.chartsOption);
                window.addEventListener('resize', () => {
                    this.chart.resize()
                })
            },

            chartresize(){
                this.chart.resize()
            },
        }
    }
</script>

<style scoped>
    .echarts{
        width: 100%;
        height: 100%;
    }

</style>
